import { workerService } from '@/services';
import MobileWorkerDetailVM from '@/view-model/worker/MobileWorkerVM';
import { vuexEventPathGenerator } from '@/utils';
import { MutationTypeList as WorkerMutationType } from './mutations';
export const actionType = {
    getWorker: 'getWorker',
    getWorkerList: 'getWorkerList',
    setWorkerSelectedHub: 'setWorkerSelectedHub',
    increaseTestValue: 'increaseTestValue',
    quickConfigureWorker: 'quickConfigureWorker',
    isPhoneExist: 'isPhoneExist',
    isHubEmployeeNumberExist: 'isHubEmployeeNumberExist',
    postWorker: 'postWorker',
    editWorkerBasic: 'editWorkerBasic',
    editWorkerWork: 'editWorkerWork',
    editWorkerPrivacy: 'editWorkerPrivacy',
    editWorkerPermission: 'editWorkerPermission',
    clearWorker: 'clearWorker',
};
// export const workerActionType = prependModuleName<typeof ActionTypes>('worker', ActionTypes);
export const workerActionType = vuexEventPathGenerator(actionType, 'worker');
const action = {
    [actionType.increaseTestValue]({ commit }, value) {
        commit(WorkerMutationType.INCREASE_TEST_VALUE, value);
    },
    async [actionType.getWorkerList]({ commit, rootGetters }, payload = {}) {
        let hubIds = payload.hubIds ?? rootGetters['user/hubId'];
        // eslint-disable-next-line
        hubIds = Array.isArray(hubIds) ? hubIds : [hubIds];
        const { attendCode = [], pageNumber = 1, pageSize = 20, } = payload;
        const response = await workerService.getWorkerListMobile({
            hubIds,
            attendCode,
            pageNumber,
            pageSize,
        });
        const result = response.list.map((data) => new MobileWorkerDetailVM(data));
        commit(WorkerMutationType.SET_WORKER_LIST, result);
    },
    [actionType.setWorkerSelectedHub]({ commit }, payload) {
        commit(WorkerMutationType.SET_WORKER_SELECTED_HUB, payload);
    },
    async [actionType.quickConfigureWorker](context, payload = {}) {
        const { hubId = '', codes = [], orderDelayTimeSecond = 0, maxAllocateCount = 10, acceptedOrderViewLimitCount = 0, } = payload;
        const response = await workerService.quickConfigureWorker({
            hubId,
            codes: Array.isArray(codes) ? codes : [
                codes,
            ],
            orderDelayTimeSecond,
            maxAllocateCount,
            acceptedOrderViewLimitCount,
        });
        return response.data;
    },
    async [actionType.isPhoneExist](context, { phone }) {
        const response = await workerService.isPhoneExist({
            phone,
        });
        return response.data;
    },
    async [actionType.isHubEmployeeNumberExist](context, { hubEmployeeNumber }) {
        const response = await workerService.isHubEmployeeNumberExist({
            hubEmployeeNumber,
        });
        return response.data;
    },
    async [actionType.postWorker]({ rootGetters }, payload) {
        try {
            const distributorId = rootGetters['user/distributorId'];
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            await workerService.postWorker({
                hubId,
                distributorId,
                ...payload,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            console.log('[postWorker] ', message, reason);
            return {
                isSuccess: false,
                message,
                reason,
            };
        }
    },
    async [actionType.getWorker]({ commit }, payload = {}) {
        const { workerCode = '' } = payload;
        const response = await workerService.getWorker({
            workerCode,
        });
        response.data = new MobileWorkerDetailVM(response.data);
        commit(WorkerMutationType.SET_WORKER, response.data);
    },
    [actionType.clearWorker]({ commit }) {
        commit(WorkerMutationType.SET_WORKER, null);
    },
    async [actionType.editWorkerBasic](context, payload = {}) {
        const { workerCode = '', name = '', telNumber = '', workerRegDate = '', depositBaromoney = 0, memo = '', } = payload;
        const response = await workerService.editWorkerBasic({
            workerCode,
            name,
            telNumber,
            workerRegDate,
            depositBaromoney,
            memo,
        });
        return response.data;
    },
    async [actionType.editWorkerWork](context, payload = {}) {
        const { workerCode = '', workTime = '', statusCode = '', employeeType = '', salaryType = '', cardDeviceType = '', } = payload;
        const response = await workerService.editWorkerWork({
            workerCode,
            workTime,
            statusCode,
            employeeType,
            salaryType,
            cardDeviceType,
        });
        return response.data;
    },
    async [actionType.editWorkerPrivacy](context, payload = {}) {
        const { workerCode = '', socialNumber = '', carNumber = '', licenseNumber = '', } = payload;
        const response = await workerService.editWorkerPrivacy({
            workerCode,
            socialNumber,
            carNumber,
            licenseNumber,
        });
        return response.data;
    },
    async [actionType.editWorkerPermission](context, payload = {}) {
        const { workerCode = '', isForceGpsOn = false, orderDelayTimeSecond = 0, acceptedOrderViewLimitCount = 0, isSharedOrderHidden = false, maxAllocateCount = 0, minFinishMinuteAfterAllocated = 0, isPossibleAllocateCancel = false, isPossiblePickupExpectedAtChange = false, isPossibleDropAddressChange = false, isPossiblePayMethodChange = false, workerDeliveryFeeGroup = 0, } = payload;
        const response = await workerService.editWorkerPermission({
            workerCode,
            isForceGpsOn,
            orderDelayTimeSecond,
            acceptedOrderViewLimitCount,
            isSharedOrderHidden,
            maxAllocateCount,
            minFinishMinuteAfterAllocated,
            isPossibleAllocateCancel,
            isPossiblePickupExpectedAtChange,
            isPossibleDropAddressChange,
            isPossiblePayMethodChange,
            workerDeliveryFeeGroup,
        });
        return response.data;
    },
};
export default action;
